export const motionTypes = [
  { label: 'Todos', value: 'todos' },
  { label: 'Petição Inicial', value: 'peticao_inicial' },
  { label: 'Petição Diversa', value: 'peticao_diversa' },
  { label: 'Contestação', value: 'contestacao' },
  { label: 'Razões Apelação', value: 'razoes_apelacao' },
  { label: 'Contrarrazões Apelação', value: 'contrarazoes_apelacao' },
  { label: 'Manifestação sobre Contestação', value: 'manifestacao_sobre_contestacao' },
  { label: 'Recurso Diverso', value: 'recurso_diverso' },
  { label: 'Contrarrazões', value: 'contrarazoes' },
  { label: 'Recurso', value: 'recurso' },
]

export const motionTypesMap = motionTypes.reduce(
  (acc, { label, value }) => acc.set(value.toLowerCase(), { label }),
  new Map()
)
